"use strict";

import axios from "axios"

Vue.component("bsn-archive", {
    data() {
        return {
            selectedRoute: document.querySelector(".year-selector").querySelectorAll('option:checked')[0].value,
            archiveListContent: null,
        }
    },
    methods: {
        changeYear: function () {
            axios.get(this.$data.selectedRoute)
                .then((response) => {
                    this.$data.archiveListContent = response.data;
                }).catch((error) => {
                console.log(error);
            });
        }
    },
    mounted() {
        console.log(this.selectedRoute);
        axios.get(this.$data.selectedRoute)
            .then((response) => {
                this.$data.archiveListContent = response.data;
            }).catch((error) => {
            console.log(error);
        });
    }
});


// WEBPACK FOOTER //
// ./frontend/js/archive.js